import { render } from "./AddMsPunsMessageForm.vue?vue&type=template&id=5201b8e4"
import script from "./AddMsPunsMessageForm.vue?vue&type=script&lang=js"
export * from "./AddMsPunsMessageForm.vue?vue&type=script&lang=js"

import "./AddMsPunsMessageForm.vue?vue&type=style&index=0&id=5201b8e4&lang=scss"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "5201b8e4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5201b8e4', script)) {
    api.reload('5201b8e4', script)
  }
  
  module.hot.accept("./AddMsPunsMessageForm.vue?vue&type=template&id=5201b8e4", () => {
    api.rerender('5201b8e4', render)
  })

}

script.__file = "src/components/ms-puns-message/AddMsPunsMessageForm.vue"

export default script